
import ScrollHint from 'scroll-hint'

export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.toggleProgramVisibility();
    this.scrollHint();
  }

  /**
   * カスタム関数
   */

  scrollHint() {
    if ($(".js-scrollable").length === 0) return;

    new ScrollHint('.js-scrollable', {
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  }

  toggleProgramVisibility() {
    $('.js-program-btn').click(function(){

      $(this).parent().toggleClass("is-visible");
      if ($(".js-program-list").hasClass("is-visible")) {
        $(".js-program-list").hide();
        $(".js-program-list").removeClass("is-visible")
      } else {
        $(".js-program-list").slideDown(200);
        $(".js-program-list").addClass("is-visible");
      }
    });
  }

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }


  // 複製して作業
  mycode() {

  }


}




